// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1IIf1","clinicsSelect":"TableHeading_clinicsSelect__2VEdz"};